import { apiRequest } from "../../../services/api_services/ApiServices";

const apiUrl = process.env.REACT_APP_API_URL;
const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
const profileUrl = process.env.REACT_APP_ADMIN_API_URL;

export const getcheckAPi = async (transactionId) => {
  try {
    return await apiRequest({
      method: "GET",
      url: `${apiUrl}/scan?transaction_id=${transactionId}`,
    });
  } catch (err) {
    console.error("Error fetching check API:", err);
  }
};

export const getbasicDetAPi = async () => {
  try {
    return await apiRequest({
      method: "GET",
      url: `${profileUrl}/basicprofile`,
    });
  } catch (err) {
    console.error("Error fetching basic profile:", err);
  }
};

export const getOrgLogoApi = async () => {
  try {
    return await apiRequest({
      method: "GET",
      url: `${accountsUrl}/get_org_image`,
    });
  } catch (err) {
    console.error("Error fetching org logo:", err);
  }
};

export const updateProfileImageApi = async (data) => {
  try {
    const response = await apiRequest({
      method: "POST",
      url: `${profileUrl}/user/image_update`,
      data,
    });
    return { status: 200, data: response };
  } catch (err) {
    console.error("Error updating profile image:", err);
    return { status: 500, data: err };
  }
};

export const getOrgListApi = async () => {
  try {
    return await apiRequest({
      method: "GET",
      url: `${profileUrl}/get_enrolled_orgs`,
    });
  } catch (err) {
    console.error("Error fetching org list:", err);
  }
};

export const getSwitchAccountApi = async (id) => {
  try {
    const response = await apiRequest({
      method: "GET",
      url: `${accountsUrl}/switch_org/${id}`,
    });
    // ProfilePopup relies on response.status structure, mock it:
    return { status: 200, data: response };
  } catch (err) {
    console.error("Error switching account:", err);
    return { status: 500, data: err };
  }
};
